const BASE = 'technical/program-planner';

export const getProgramPlannerListApi = () => `${BASE}/plans`;
export const createProgramPlanApi = () => `${BASE}/plans`;
export const getProgramPlanDetailApi = (planSlug) => `${BASE}/plans/${planSlug}`;
export const updateProgramPlanApi = (planSlug) => `${BASE}/plans/${planSlug}`;
export const deleteProgramPlanApi = (planSlug) => `${BASE}/plans/${planSlug}`;
export const markPlanReadyApi = (planSlug) => `${BASE}/plans/${planSlug}/mark-ready`;
export const launchProgramPlanApi = (planSlug) => `${BASE}/plans/${planSlug}/launch`;
export const cancelProgramPlanApi = (planSlug) => `${BASE}/plans/${planSlug}/cancel`;
export const closeProgramPlanApi = (planSlug) => `${BASE}/plans/${planSlug}/close`;
export const exportProgramPlannerListApi = () => `${BASE}/plans`;

export const getPlannerAssetsApi = () => `${BASE}/assets`;

export const uploadRepCvApi = (planSlug, repRowId) => `${BASE}/plans/${planSlug}/reps/${repRowId}/upload-cv`;

export const getTeamMembersApi = () => `${BASE}/team-members`;

export const getStageTemplatesApi = () => `${BASE}/stage-config-templates`;
export const getStageTemplateStagesApi = (templateId) => `${BASE}/stage-config-templates/${templateId}/stages`;

export const getStagePreviewApi = (planSlug) => `${BASE}/plans/${planSlug}/stage-preview`;
export const changePlanStageApi = (planSlug) => `${BASE}/plans/${planSlug}/change-stage`;

export const getLessorsListApi = () => 'console/lessors/';
export const getLesseesListApi = () => 'console/lessees/';
export const getInspectionTypesApi = () => 'technical/inspection-types/';
